import clsx from 'clsx'
import React from 'react'
import {Link} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Topbar} from './Topbar'

export function HeaderWrapper() {
  const {config, classes, attributes} = useLayout()
  const {header, aside} = config

  return (
    <div id='kt_header' className={clsx('header', classes.header.join(' '), 'align-items-stretch')} {...attributes.headerMenu}>
      <div className={clsx(classes.headerContainer.join(' '), 'd-flex align-items-stretch justify-content-between gap-4')}>
        {aside.display && (
          <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
            <div className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px' id='kt_aside_mobile_toggle'>
              <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-2x mt-1' />
            </div>
          </div>
        )}

        {aside.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 gap-4'>
            <Link to='/'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo_reversed.svg')} className='h-40px h-lg-60px' />
            </Link>
            <div className='d-none d-sm-flex flex-column'>
              <span className='m-0 lh-1 fs-sm-5 fs-lg-5 fw-semibold text-muted'>GDRN</span>
              <span className='m-0 lh-1 fs-sm-4 fs-lg-2 fw-bold'>Information Management Portal</span>
            </div>
          </div>
        )}

        {/* begin::Wrapper */}
        <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
          <div className='d-flex align-items-center' id='kt_header_nav'></div>

          <div className='d-flex align-items-stretch flex-shrink-0'>
            <Topbar />
          </div>
        </div>
        {/* end::Wrapper */}
      </div>
    </div>
  )
}
